import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './english'
import fr from './french'

const messages = { en, fr }

Vue.use(VueI18n)
// Create VueI18n instance with options
export default new VueI18n({
    locale: 'en', // set locale
    messages, // set language
    theme: {},
    silentTranslationWarn: true // turn off no translation warning
})